





































import {
  computed,
  defineComponent,
  PropType,
  ref,
} from '@nuxtjs/composition-api'
import { sectionCoreProps } from '@/mixins/sectionCore'
import SectionBasic from '@/components/SectionBasic.vue'
import { CardTitleDescriptionImage as ICardTitleDescriptionImage } from '@/contracts/Cards'
import CardTitleDescriptionImage from '@/components/Cards/CardTitleDescriptionImage.vue'

export default defineComponent({
  name: 'SectionCardsTitleDescriptionImage',
  components: { CardTitleDescriptionImage, SectionBasic },
  mixins: [sectionCoreProps],
  props: {
    cols: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    cards: {
      type: Array as PropType<ICardTitleDescriptionImage[]>,
      default: () => [],
    },
    tabs: {
      type: Array as any,
      default: () => [],
    },
  },
  setup(props) {
    // реактивное свойство для выбранной вкладки
    const activeTab = ref('all')

    // вычисляемое свойство для фильтрации карточек
    const filteredCards = computed(() => {
      // Если выбрана вкладка "all", возвращаем все карточки
      if (activeTab.value === 'all') {
        return props.cards
      }
      // Иначе фильтруем по полю filterValue
      return props.cards.filter((card) => card.filterValue === activeTab.value)
    })

    return {
      activeTab,
      filteredCards,
    }
  },
})
